module.exports = __webpack_public_path__ + "img/instagram.f6d307e4.svg";